import {Box, Container, Grid, Paper, Typography} from "@mui/material";
import useThemeStore from "../../store/theme";

const Services = () => {
    return (
        <Container sx={{ mt: 10 }}>
            <Typography variant="h6">مزایای استفاده از میلفا</Typography>
            <Grid mt={2} container spacing={3}>
                <Grid item xs={12} lg={3}>
                    <Service
                        title="امنیت بالا"
                        description="دارای چندین لایه امنیتی و استفاده از به روز ترین متد های امنیتی."
                        icon="/assets/image/icon/server.png"/>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Service
                        title="پهنای باند نامحدود"
                        description="بدون نگرانی از دچار افت سرعت فایل های خودتون رو دانلود یا آپلود کنید."
                        icon="/assets/image/icon/bandwidth.png"/>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Service
                        title="قابلیت فروش فایل"
                        description="آپلود فایل های اختصاصی فروشی، بعد از پرداخت مبلغ مورد نظر شما دسترسی به فایل خواهید داشت."
                        icon="/assets/image/icon/folder.png"/>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Service
                        title="خصوصی سازی"
                        description="با استفاده از قابلیت رمز گذاری دسترسی فایل های خود را برای دیگران محدود کنید."
                        icon="/assets/image/icon/secure-folder.png"/>
                </Grid>
            </Grid>
        </Container>
    )
}
export default Services;

const Service = ({title, description, icon}) => {

    const themeMode = useThemeStore(state => state.mode);
    const Icon = () => {
        return (
            <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "center", width: "5rem", height: "5rem", borderRadius: "50%", background: theme => theme.palette.primary.main, border: "2px solid #fff", boxShadow: 25 }}>
                <Box component="img" alt="Icon" src={icon} width={1} height={1} sx={{ objectFit: "contain" }}/>
            </Box>
        )
    }

    return (
        <Paper sx={{ p: 2.5, height: 1, display: "flex", alignItems: "center", flexDirection: "column", backgroundColor: themeMode === 'light' ? "#bdbdbd" : "#5d5d62" }}>
            <Icon/>
            <Typography mt={2.5} fontSize={{ xs: "1.1rem" }} fontWeight={600} textAlign="center">{title}</Typography>
            <Typography mt={2} textAlign="center">{description}</Typography>
        </Paper>
    )
}